import { adminLog, adminLogError } from './adminLog';
import { prepareHeadshot } from './prepareHeadshot';

export async function uploadMedia(file: File): Promise<string> {
  adminLog('image.upload_started', { fileName: file.name, bytes: file.size, contentType: file.type });
  const formData = new FormData();
  formData.append('file', await prepareHeadshot(file));

  const response = await fetch('/api/admin/media', { method: 'POST', body: formData });
  const result = await response.json().catch(() => null);
  if (!response.ok || !result?.url) {
    const error = new Error(result?.error || 'The photo could not be uploaded.');
    adminLogError('image.upload_failed', error, { fileName: file.name });
    throw error;
  }
  adminLog('image.upload_succeeded', { fileName: file.name });
  return result.url;
}
